import { environment } from 'environments/environment';

export const GlobalVariable = Object.freeze({
    BASE_UI_URL: environment.baseUrl,
    BASE_API_URL: environment.baseApiUrl,
    HOST_M_SITE_ES: environment.host_es,
    HOST_M_SITE_E: environment.host_en,
    rewardsUrl: environment.rewardsUrl,
    rewardsApiKey: environment.rewardsApiKey,
});

export let WebChatVariables = environment.webChatVariables;

export let AzureSearchVariables = environment.azureSearchVariables;

export let ElasticSearch = {
    url: ''
};



// WEBPACK FOOTER //
// ./src/app/shared/global.ts